@if (menuParams) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="menuParams">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Variable Name </label>
              <app-cms class="popover" [type]="'nodeBuild'" [field]="'varName'"></app-cms>
            </div>
            <ng-container *ngTemplateOutlet="validators; context: { myControlName: 'varName', myForm: menuParams}">
            </ng-container>
            <input class="control-input" activeForm [activeForm]="menuParams" id="varName" type="text" [formControlName]="'varName'" placeholder="Enter the name of the node"/>
          </div>
          <br>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Message To User </label>
                <app-cms class="popover" [type]="'nodeBuild'" [field]="'fallbackMessage'"></app-cms>
              </div>
              <ng-container
                *ngTemplateOutlet="validators; context: { myControlName: 'text', myForm: menuParams}">
              </ng-container>
              <textarea class="control-textArea" activeForm [activeForm]="menuParams" id="usrmsg" [formControlName]="'text'"
              placeholder="Enter a body text" style="resize: none"></textarea>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Validation Message </label>
                <app-cms class="popover" [type]="'nodeBuild'" [field]="'validationMessage'"></app-cms>
              </div>
              <ng-container
                *ngTemplateOutlet="validators; context: { myControlName: 'validationMessage', myForm: menuParams}">
              </ng-container>
              <textarea class="control-textArea" activeForm [activeForm]="menuParams" id="validationmsg" [formControlName]="'validationMessage'"
              placeholder="Preheader text..." style="resize: none; min-height: 80px !important;"></textarea>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Select Contact Fields </label>
                <app-cms class="popover" [type]="'nodeBuild'" [field]="'selectContactFieldsMessage'"></app-cms>
                @if (showErrorBox == errorBoxStates.error) {
                  <div class="validationField">
                    <span class="fa fa-exclamation-circle"></span>
                    <span [id]="'validationField-ContactFields'">
                      Please Select a Contact Field
                    </span>
                  </div>
                }
              </div>
              <ng-container
                *ngTemplateOutlet="CheckboxFields; context: { myControlName: 'lastname', myForm: menuParams}">
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </clickatell-expansion-panel>
      <clickatell-expansion-panel>
        <ng-container header>
          <mat-panel-title>
            Logic
          </mat-panel-title>
        </ng-container>
        <ng-container body>
          <div class="control-div">
            <label class="control-label">
              <span class="pont-to">Point To</span>
            </label>
            <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
            @if (nodeFlowDetails) {
              <next-selector [canEditFlows]="canEdit.canEditFlows" [selectorType]="'both'"
                [flowSteps]="nodeFlowDetails.currentFlowSteps" [flows]="nodeFlowDetails.flows"
                [stepId]="nodeFlowDetails.stepId"
                [name]="'next'"
                [form]="menuParams">
              ></next-selector>
            }
          </div>
        </ng-container>
      </clickatell-expansion-panel>
    </div>
  }

  <ng-template #validators let-myControlName="myControlName" let-myForm=myForm>
    @if (myForm.controls[myControlName]; as control) {
      @if (control.invalid && (control.dirty || control.touched)) {
        <div class="validationField">
          @for (error of control.errors | keyvalue; track error) {
            <div>
              <span class="fa fa-exclamation-circle"></span>
              <span [id]="'validationField-' + myControlName">
                {{error.value}}
              </span>
            </div>
          }
        </div>
      }
    }
  </ng-template>

  <ng-template #CheckboxFields>
    <ng-container [formGroup]="menuParams">
      <div class="checkbox-box" formGroupName="validateFields">
        <div class="checkbox-container">
          <input (change)="selectAll(); changeColor($event)" type="checkbox" id="select-all-checkbox" name="contact" class="check_box " value="select-all" [checked]="isAnyTrue"  />
          <label for="select-all-checkbox"></label>
          <label>Select All</label>
        </div>

        <div class="checkbox-container">
          <input (change)="partiallySelected($event); changeColor($event)" class="check_box" type="checkbox" id="address" name="contact" value="address" [formControlName]="'address'"/>
          <label for="address"></label>
          <label>Address</label>
        </div>

        <div class="checkbox-container">
          <input (change)="partiallySelected($event); changeColor($event)" class="check_box" type="checkbox" id="fname" name="contact" value="name" [formControlName]="'name'"/>
          <label for="fname"></label>
          <label>Name</label>
        </div>

        <div class="checkbox-container">
          <input (change)="partiallySelected($event); changeColor($event)" class="check_box" type="checkbox" id="phone" name="contact" value="phone" [formControlName]="'phone'"/>
          <label for="phone"></label><br>
          <label>Phone</label>
        </div>

        <div class="checkbox-container">
          <input (change)="partiallySelected($event); changeColor($event)" class="check_box" type="checkbox" id="birthday" name="contact" value="birthday" [formControlName]="'birthday'"/>
          <label for="birthday"></label><br>
          <label>Birthday</label>
        </div>

        <div class="checkbox-container">
          <input (change)="partiallySelected($event); changeColor($event)" class="check_box" type="checkbox" id="url" name="contact" value="url" [formControlName]="'url'"/>
          <label for="url"></label><br>
          <label>Url</label>
        </div>

        <div class="checkbox-container">
          <input (change)="partiallySelected($event); changeColor($event)" class="check_box" type="checkbox" id="org" name="contact" value="org" [formControlName]="'org'"/>
          <label for="org"></label><br>
          <label>Organisation</label>
        </div>
      </div>
    </ng-container>

  </ng-template>